export default __webpack_public_path__ + "static/media/alert.inline.ef4ba10f.svg";